<template>
  <div class="bg-container">
    <div>
      <img src="@/assets/images/bday/banner1.svg" class="banner1 banner">
      <img src="@/assets/images/bday/banner2.svg" class="banner2 banner">
      <img class="labour-love" src="@/assets/images/labour-love.svg">

      <div class="bear-bday">
        <img src="@/assets/images/bday/bear.svg">
        <img src="@/assets/images/bday/bear-hat.svg" class="bear-hat">
      </div>
      <img src="@/assets/images/bday/gift1.svg" class="gift gift1">
      <img src="@/assets/images/bday/gift2.svg" class="gift gift2">
      <img src="@/assets/images/bday/gift3.svg" class="gift gift3">

      <div class="balloons">
        <balloon
          v-if="babies[0]"
          class="balloon1"
          :celebrant="`${babies[0].firstname} ${mName(babies[0].middlename)} ${babies[0].lastname}`"
          :initial-theme="1"
          :balloon-type="1"></balloon>
        <balloon
          v-if="babies[1]"
          class="balloon2"
          :celebrant="`${babies[1].firstname} ${mName(babies[1].middlename)} ${babies[1].lastname}`"
          :initial-theme="2"
          :balloon-type="2"></balloon>
        <balloon
          v-if="babies[2]"
          class="balloon3"
          :celebrant="`${babies[2].firstname} ${mName(babies[2].middlename)} ${babies[2].lastname}`"
          :initial-theme="3"
          :balloon-type="3"></balloon>
      </div>

      <div class="bear-thumb">
        <img src="@/assets/images/bday/bear-thumb.svg">
      </div>

      <div class="copy-container">
        <div
          class="month"
          :class="month.length >= 8 ? 'smaller' : ''">{{month}}
        </div>
        <div class="copy-birthdays">BIRTHDAYS</div>
      </div>
    </div>
  </div>
</template>

<script>
import { TimelineMax, Back, Power4, Power0 } from 'gsap'
import Balloon from '@/components/BirthdaySlide/Balloon.vue'
import SplitText from '@/assets/gsap-bonus/SplitText'
import { mapGetters } from 'vuex'

export default {
  name: 'BirthdaySlide',

  components: {
    Balloon
  },
  data () {
    return {
      tlBdays: new TimelineMax(),
      month: ''
    }
  },

  computed: {
    ...mapGetters(['activeSlide']),

    babies () {
      return this.activeSlide.babies
    }
  },

  created () {
    // Get current month
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ]
    this.month = months[new Date(this.$store.state.dateTime).getMonth()]
  },
  mounted () {
    const banners = this.$el.querySelectorAll('.banner')
    const bear = this.$el.querySelector('.bear-bday')
    const bearThumb = this.$el.querySelector('.bear-thumb')
    const bearHat = this.$el.querySelector('.bear-hat')
    const balloonGrp = this.$el.querySelector('.balloons')
    const gifts = this.$el.querySelectorAll('.gift')
    const month = this.$el.querySelector('.month')
    const birthdays = this.$el.querySelector('.copy-birthdays')
    const monthSplit = new SplitText(month, { type: 'chars', charsClass: 'month-char' })
    const names = this.$el.querySelectorAll('.celebrant-text')
    const namesBg = this.$el.querySelectorAll('.name-bg')

    this.tlBdays
      .delay(1.2)
      .set(bearHat, { top: 0 })
      .set([...names, ...namesBg], { transformOrigin: '50% 50%' })
      .from(banners, 0.7, { yPercent: -105, ease: Back.easeOut })
      .from([bear, balloonGrp, bearThumb], 1.4, { yPercent: -200, ease: Back.easeOut.config(0.7) }, 0.3)
      .from(bearHat, 1.4, { yPercent: -20 }, 0.3)
      .add('gitfsIn', 0.85)
      .staggerFrom(gifts, 0.35, { opacity: 0 }, 0.1, 'gitfsIn')
      .staggerFrom(gifts, 0.7, { yPercent: -30, ease: Back.easeInOut.config(2.5) }, 0.1, 'gitfsIn')
      .add('headlineIn', '-=0.2')
      .from(birthdays, 1.5, { opacity: 0 }, 'headlineIn')
      .staggerFrom(monthSplit.chars, 1.5, { yPercent: 100, ease: Power4.easeOut }, 0.05, 'headlineIn')
      .add('names')
      .staggerFromTo(names, 0.4, { scale: 0 }, { scale: 1 }, 0.15, 'names')
      .staggerTo(namesBg, 0.2, { scaleX: 1.04, ease: Power0.easeNone, yoyo: true, repeat: 1 }, 0.15, 'names+=0.2')
  },
  watch: {
    babies (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.tlBdays.seek('names')
      }
    }
  },
  beforeDestroy () {
    this.tlBdays.kill()
  },
  methods: {
    mName (m) {
      return m == null ? '' : m
    }
  }
}
</script>

<style scoped>
  .bg-container {
    background: #fffced;
    width: 100vw;
    height: 100vh;
  }

  .banner1 {
    position: absolute;
    top: -2vw;
    left: -2vw;
    width: 30vw;
  }

  .banner2 {
    position: absolute;
    top: -2vw;
    right: -2vw;
    width: 30vw;
  }

  .bear-bday,
  .bear-thumb {
    position: absolute;
    bottom: 0.5vw;
    width: 31.7vw;
    right: 14.2vw;
    z-index: 1;
  }

  .bear-hat {
    position: absolute;
    top: -100vh;
    left: 0;
  }

  .bear-thumb {
    z-index: 5;
  }

  .gift {
    position: absolute;
  }

  .gift1 {
    right: 11.5vw;
    width: 12vw;
    bottom: 2vw;
    z-index: 3;
  }

  .gift2 {
    right: 6.5vw;
    width: 9.1vw;
    bottom: 6.3vw;
    z-index: 2;
  }

  .gift3 {
    right: 35.2vw;
    width: 12vw;
    bottom: 9vw;
  }

  .labour-love {
    position: absolute;
    left: 4.35vw;
    bottom: 3.5vw;
    width: 7.5vw;
    height: auto;
  }

  .month {
    font-weight: 500;
    font-size: 10vw;
    overflow: hidden;
  }

  .month.smaller {
    font-size: 8.8vw;
  }

  .copy-birthdays {
    font-size: 5vw;
    letter-spacing: 0.1em;
    font-weight: 300;
  }

  .copy-container {
    font-family: 'Barlow', sans-serif;
    color: #56beca;
    position: absolute;
    top: 18.8vw;
    left: 2vw;
    width: 45vw;
    text-align: center;
  }

  .balloons {
    position: absolute;
    width: 100vw;
    height: 100vh;
    z-index: 2;
  }

  .balloon {
    position: absolute;
    z-index: 4;
    animation: skew;
    -webkit-animation-direction: alternate;
    -moz-animation-direction: alternate;
    -o-animation-direction: alternate;
    animation-direction: alternate;
    animation-duration: 2.5s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    transform-origin: 0% 90%;
  }

  @keyframes skew {
    0% {
      transform: skewX(2deg);
    }
    100% {
      transform: skewX(-2deg);
    }
  }

  .balloon1 {
    width: 20vw;
    bottom: 15.3vw;
    right: 39vw;
  }

  .balloon2 {
    width: 12vw;
    bottom: 18.3vw;
    right: 37.45vw;
    animation-delay: 0.15s;
  }

  .balloon3 {
    width: 10.9vw;
    bottom: 17.3vw;
    right: 27.95vw;
    animation-delay: 0.3s;
  }
</style>



// WEBPACK FOOTER //
// src/components/BirthdaySlide.vue